import React, {useState} from 'react';
import clsx from "clsx";
import {format, parseISO} from "date-fns";
import {CheckMark, SmallCloseIcon} from "../icons";
import {Popover} from "./index";
import {IResult, PAGINATION, TABLE_STATUSES} from "../../types";

interface IClassNames {
  [key: string]: string
}

const Table = ({ results }: { results: Array<IResult>}) => {
  const [showPopover, setShowPopover] = useState<boolean>(false);
  const [idxPopover, setIdxPopover] = useState<number | null>(null);

  const classNames: IClassNames = {
    [TABLE_STATUSES.OPENED]: "text-green bg-green/20",
    [TABLE_STATUSES.PENDING]: "text-blue bg-blue/20",
    [TABLE_STATUSES.CLOSED]: "text-red bg-red/20",
  }

  const hoverIn = (idx: number) => {
    setShowPopover(true);
    setIdxPopover(idx);
  }

  const hoverOut = () => {
    setShowPopover(false);
    setIdxPopover(null);
  }

  const setStatusIcon = (status: string , text: string) => {
    switch (status) {
      case TABLE_STATUSES.OPENED:
        return <> <CheckMark /> {text} </>

      case TABLE_STATUSES.PENDING:
        return <> <CheckMark stroke="blue" /> {text} </>

      case TABLE_STATUSES.CLOSED:
        return <> <SmallCloseIcon />  {text} </>

      default:
        return <></>
    }
  }

  return (
    <table className="mt-6 w-full">
      <thead>
        <tr className="border-b border-b-solid border-b-gray text-mainBlack/75 text-[12px] leading-[14px]">
          <td className="px-3 py-4 w-2/5">Организация</td>
          <td className="px-3 py-4">Дата</td>
          <td className="px-3 py-4">Продукт</td>
          <td className="px-3 py-4">Вознаграждение</td>
          <td className="px-3 py-4">Статус заявки</td>
          <td className="px-3 py-4">Дата открытия</td>
        </tr>
      </thead>
      <tbody>
      {
        results?.map((i, index) => (
          <tr
            key={index}
            className="relative text-black text-[14px] leading-[16px] hover:bg-mainBlack/5 duration-150 ease-in cursor-pointer"
            onMouseEnter={() => hoverIn(index)}
            onMouseLeave={hoverOut}
          >
            <td className="px-3 py-4 w-2/5">{i.organisation}</td>
            <td className="px-3 py-4 text-mainBlack/60">{i?.created && format(parseISO(i?.created), 'dd-MM-yyyy')}</td>
            <td className="px-3 py-4">{i.name}</td>
            <td className="px-3 py-4">{i.reward}</td>
            <td className="px-3 py-4">
              <span className={
                clsx(
                  "inline-flex items-center gap-1 py-1 px-2 rounded-[4px] whitespace-nowrap",
                  classNames[i?.status?.status as keyof IClassNames]
                )
              }>
                {setStatusIcon(i?.status?.status, i?.status?.label)}
              </span>
            </td>
            <td className="px-3 py-4 text-mainBlack/60">{i?.opened && format(parseISO(i?.opened), 'dd-MM-yyyy')}</td>
            {showPopover && index === idxPopover && results?.[idxPopover]?.scoring_info &&
              <td className={
                clsx(
                  "absolute left-0 top-[100%] z-10",
                  results.length === PAGINATION.PAGE_SIZE && index >= PAGINATION.PAGE_SIZE - 1 &&
                  "top-auto bottom-[100%]"
                )
              }>
                <Popover info={i?.scoring_info} />
              </td>
            }
          </tr>
        ))
      }
      </tbody>
    </table>
  )
};

export default Table;
